import { authClient } from './client'
import type { ModuleStatus, ModuleKey } from '../types'

export const getBusinessModules = (businessId: string) =>
  authClient.get<ModuleStatus[]>(`/auth/businesses/${businessId}/modules`)

export const setBusinessModule = (businessId: string, moduleKey: ModuleKey, isEnabled: boolean) =>
  authClient.put(`/auth/businesses/${businessId}/modules/${moduleKey}`, { isEnabled })
